import mobx, { observable, action, computed, autorun } from 'mobx';
import _ from 'lodash';
import api from '../../api';

export default class AccountPage {

	@observable data = null;
	@observable wait = false;
	@observable isLoading = true;
	@observable password = {
		pass1 : '',
		pass2: '',
		pass3: ''
	};
	@observable result = {
		error: '',
		success: ''
	};
	@observable error = {
		status: 0,
		text: ''
	};


	constructor(store, data) {
		this.store = store;
		// this.getData();
	}

	@action init() {
		this.getData();
	}

	@action getData() {
		return api.user.getAccountData().then(
				action(
					res => {
						if (res.code == 'OK') {
							this.data = res.result;
						} else {
							this.setError(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setError('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.isLoading = false; }));
	}

	@action setError(text) {
		this.error.status = 1;
		this.error.text = text;
	}

	@action clearError() {
		this.error.status = 0;
		this.error.text = '';
	}

	@action setError(text) {
		this.result.error = text;
	}f

	@action inputPass(val, type) {
		const number = val.replace(/\D+/g,"");
    this.result.error = '';
		if (number.toString().length > 0){
  		this.password[`pass${type}`] = number;
    } else {
      this.password[`pass${type}`] = '';
    }
	}

	@action savePass() {
		this.wait = true;
		this.result.error = '';
		this.result.success = '';
		let data = {
			'password' : this.password.pass1,
			'new_password' : this.password.pass2,
			'new_password2' : this.password.pass3,
		}
		return api.user.savePass(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.result.success = 'PASSWORD_CHANGED_SUCCESSFULLY';
							this.password.pass1 = '';
							this.password.pass2 = '';
							this.password.pass3 = '';
							setTimeout(() => {
								this.result.success = '';
								this.store.changePsw = 0;
							}, 2000);
						} else {
							this.result.error = (res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.result.error = ('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.wait = false; }));
	}
}


// WEBPACK FOOTER //
// ./src/stores/accountStore/account.js